import { render, staticRenderFns } from "./Idenfy.vue?vue&type=template&id=dee6227c&"
import script from "./Idenfy.vue?vue&type=script&lang=js&"
export * from "./Idenfy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports